import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AdminAuthProvider, useAdminAuth } from "@/context/AdminAuthContext";
import { Toaster } from "@/components/ui/sonner";
import ReleasePage from "@/pages/ReleasePage";
import ReleasePageWrapper from "@/pages/ReleasePageWrapper";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

const ProtectedAdminRoute = ({ children }) => {
  const { admin } = useAdminAuth();
  if (admin === null) return <div className="min-h-screen bg-[#07090E]" />;
  if (admin === false) return <Navigate to="/admin/login" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AdminAuthProvider>
          <Toaster />
          <Routes>
            <Route path="/" element={<ReleasePage slug="nindiya-garden" />} />
            <Route path="/release/:slug" element={<ReleasePageWrapper />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedAdminRoute><AdminDashboard /></ProtectedAdminRoute>} />
          </Routes>
        </AdminAuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
